import React from "react";
import Resizer from "react-image-file-resizer";

// components
import { ImageUpload } from "../../components";

class ImagesUpload extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            file: []
        };

        this.resetState = this.resetState.bind(this);
        this.addFile = this.addFile.bind(this);
    }

    componentDidMount() {
        this.setImages(this.props.value);
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setImages(this.props.value);
        }
    }

    addFile(imageFiles) {
        const imageFile = imageFiles[0];
        const name = this.renameImage(imageFile);
        this.resizeImage(imageFile, async (compressedImage) => {
            const base64 = await this.toBase64(compressedImage);
            const file = [
                Object.assign(new File([compressedImage], name), {
                    preview: URL.createObjectURL(compressedImage),
                    base64
                })
            ];

            await this.setState({ file });
            this.props.onChange({ file });
        })
    }

    toBase64(imageFile) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(imageFile);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    renameImage(imageFile) {
        const [name, extension] = imageFile.name.split('.');
        return `${name}_${+new Date()}.${extension}`;
    };

    async resizeImage(file, callback) {
        return Resizer.imageFileResizer(
            file,
            1080,
            1440,
            "jpeg",
            75,
            0,
            (file) => {
                callback(file);
            },
            "file"
        );
    }

    resetState() {
        this.setState({
            file: [],
            beforewash:{front:[], back:[]},
            afterwash:{front:[], back:[]},
        });
    }

    setImages(images) {
        if (images) {
            this.setState({
                file: images === undefined ? [] : [{ preview: images, url: images }]
            })
        }
    }

    render() {
        return (
            <div className={this.props.angle ?null:"container" }>
                <label className="label">{this.props.angle ?null:"Picture" }</label>
                <div className="img-drag-drop first-drag">
                    <ImageUpload
                        create={this.props.create}
                        angle={this.props.angle}
                        size={this.props.size}
                        index="1"
                        addFile={this.addFile}
                        files={this.state.file}
                        disabled={this.props.disabled}
                    />
                </div>
            </div >
        );
    }
}

export default ImagesUpload;
